export function isElectron() {
  try {
    return navigator.userAgent.toLowerCase().indexOf(' electron/') > -1
  } catch (e) {
    console.error('Failed to detect if is running on electron', e)
    return false
  }
}
